import { GITHUB_URL } from "./GithubChart";

const linkedin = "https://www.linkedin.com/in/sukrit-phaopanich/";

export const Footer = ({ onOpenContact }) => {
  return (
    <footer className="site-footer" id="contact">
      <div className="stack-lid" aria-hidden="true" />
      <div className="ft-inner">
        <p className="footer-kicker reveal">Available for the next build</p>
        <h2 className="footer-headline reveal">
          Let’s build the next idea <em>together</em>.
        </h2>
        <p className="footer-lede reveal">
          I take a 0-to-1 from the bet to a product people trust, use, and can measure.
        </p>
        <div className="footer-actions">
          <a className="ft-linkedin" href={linkedin} target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.8 0 0 .77 0 1.73v20.54C0 23.22.8 24 1.77 24h20.46c.97 0 1.77-.78 1.77-1.73V1.73C24 .77 23.2 0 22.23 0z"
              />
            </svg>
            <span className="ft-linkedin-copy">
              <strong>Message me on LinkedIn</strong>
              <em>The fastest way to start a conversation</em>
            </span>
          </a>
          <button className="ft-note" type="button" onClick={onOpenContact}>
            Or send a note
          </button>
        </div>
      </div>
      <div className="footer-bar">
        <p>Sukrit Phaopanich · {new Date().getFullYear()}</p>
        <div className="footer-bar-links">
          <a href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a href={linkedin} target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
};
